<template>
  	<div id="app">
		<!-- <div v-if='!flag' class="swiper-container">
			<div class="swiper-wrapper">
				<div class="swiper-slide"><img src="./assets/images/asset_mobile_1.png" alt="" style="width:100%;height: 100%;"></div>
				<div class="swiper-slide"><img src="./assets/images/asset_mobile_2.png" alt="" style="width:100%;height: 100%;"></div>
				<div class="swiper-slide"><img src="./assets/images/asset_mobile_3.png" alt="" style="width:100%;height: 100%;"></div>
				<div class="swiper-slide"><img src="./assets/images/asset_mobile_4.png" alt="" style="width:100%;height: 100%;"></div>
				<div class="swiper-slide"><img src="./assets/images/asset_mobile_5.png" alt="" style="width:100%;height: 100%;"></div>
				<div class="swiper-slide"><img src="./assets/images/asset_mobile_6.png" alt="" style="width:100%;height: 100%;"></div>
			</div>
		</div> -->

	    <div>
			<header id="header" class="head">
				<div class="w1200">
					<div class="logo">
						<router-link to="/"  @click="toggle(9)"><img src="./assets/logo.png"></router-link>
					</div>
					<i v-if="openMenu" @click="isOpenMenu()" class="el-icon-close menu_icon"></i>
					<i v-else @click="isOpenMenu()" class="el-icon-menu menu_icon"></i>
					<!-- <a class="btn mobile" style="margin:14px;float:right" href="http://zc.91assets.com/company_register.jsp">立即注册</a> -->
					<ul class="menu">
						<!-- <li>
							<a href="http://zc.91assets.com/login.jsp">登录</a>
						</li>
						<li>
							<a  class="btn" href="http://zc.91assets.com/company_register.jsp">立即注册</a>
						</li> -->
					</ul>
					<ul class="menu">
						<!-- <li>
							<el-dropdown>
							<span class="el-dropdown-link">后勤云管家<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown" class="icon-drop">
								<el-dropdown-item><a href="https://agent.91assets.com"><img src="./assets/agent.png">后勤云服务</a></el-dropdown-item>
							</el-dropdown-menu>
							</el-dropdown>	
						</li> -->
						<li @click="toggle(9)" :class="{'active':navActive==9}">
							<router-link to="/">首页</router-link>	
						</li>
						<li @click="toggle(1)" :class="{'active':navActive==1}">
							<router-link to="/product">产品案列</router-link>	
						</li>
						<!-- <li @click="toggle(2)" :class="{'active':navActive==2}">
							<router-link to="/price">价格体系</router-link>		
						</li> -->
						<li @click="toggle(3)" :class="{'active':navActive==3}">
							<router-link to="/news">新闻动态</router-link>		
						</li>
						<!-- <li @click="toggle(4)" :class="{'active':navActive==4}">
							<router-link to="/contact">联系我们</router-link>
						</li> -->
						<li @click="toggle(4)" :class="{'active':navActive==4}">
							<el-dropdown>
							<span class="el-dropdown-link">
								关于我们<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown" class="icon-drop">
								<el-dropdown-item icon="el-icon-warning-outline">
									<router-link :to="{ path: '/contact', query: { type: 1}}">公司介绍</router-link>
								</el-dropdown-item>
								<el-dropdown-item icon="el-icon-attract">
									<router-link :to="{ path: '/contact', query: { type: 2}}">加入我们</router-link>
								</el-dropdown-item>
								<el-dropdown-item icon="el-icon-guide">
									<router-link :to="{ path: '/contact', query: { type: 3}}">代理商渠道</router-link>
									</el-dropdown-item>
								<el-dropdown-item icon="el-icon-phone">
									<router-link :to="{ path: '/contact', query: { type: 4}}">联系我们</router-link>
								</el-dropdown-item>
							</el-dropdown-menu>
							</el-dropdown>	
						</li>
					</ul>
				</div>
			</header>
			<transition name="el-zoom-in-top">
				<div class="mobile_menu transition-box" v-if="openMenu">
					<el-menu
						default-active="2"
						class="el-menu-vertical-demo"
						text-color="#fff"
						@select="selectMenu"
						active-text-color="#fff">
						<el-menu-item index="1">
							<span slot="title"><router-link to="/product">产品案列 <i class="el-icon-arrow-right"></i></router-link></span>
						</el-menu-item>
						<el-menu-item index="2">
							<span slot="title"><router-link to="/news">新闻动态<i class="el-icon-arrow-right"></i></router-link></span>
						</el-menu-item>
						<!-- <el-submenu index="3">
							<template slot="title">
								<span><router-link to="/product">关于我们</router-link>	</span>
							</template>
							<el-menu-item index="3-1"><router-link :to="{ path: '/contact', query: { type: 1}}">公司介绍<i class="el-icon-arrow-right"></i></router-link></el-menu-item>
							<el-menu-item index="3-2"><router-link :to="{ path: '/contact', query: { type: 2}}">加入我们<i class="el-icon-arrow-right"></i></router-link></el-menu-item>
							<el-menu-item index="3-3"><router-link :to="{ path: '/contact', query: { type: 3}}">代理商渠道<i class="el-icon-arrow-right"></i></router-link></el-menu-item>
							<el-menu-item index="3-4"><router-link :to="{ path: '/contact', query: { type: 4}}">联系我们<i class="el-icon-arrow-right"></i></router-link></el-menu-item>
						</el-submenu> -->
						<el-menu-item index="3">
							<span slot="title"><router-link :to="{ path: '/contact', query: { type: 1}}">公司介绍<i class="el-icon-arrow-right"></i></router-link></span>
						</el-menu-item>
						
					</el-menu>
				</div>
			</transition>
			
			<div class="content">
				<router-view></router-view>
				<footer>
					苏州创酷天下网络科技有限公司 <a style="color:#fff;font-size:12px;" href="https://beian.miit.gov.cn/">苏ICP备2023055538号-2 </a>
				</footer>

				<el-backtop target=".content" :bottom="100">
				<div style="{
					height: 100%;
					width: 100%;
					background-color: #f2f5f6;
					box-shadow: 0 0 6px rgba(0,0,0, .12);
					text-align: center;
					line-height: 40px;
					color: #1989fa;
				}">Top</div>
				</el-backtop>
			</div>
		</div>
  	</div>
</template>
<script>
	export default {
	  	name: 'app',
	  	data () {
	    	return {
				navActive:'',
				login_userName:'',
				login_password:'',
				flag:'',
				openMenu:false,
	    	}
		  },
		  created(){
			var that=this;
			// that.flag = that.isPC();
			var login_userName = localStorage.getItem("login_userName");
			var login_password = localStorage.getItem("login_password");
			if(login_userName!=''&&login_userName!=null){
				that.login_userName=login_userName
				that.login_password=login_password
			}
		  },
	  	mounted () {
			window.addEventListener('scroll', this.scrollToTop)
			var swiper = new Swiper('.swiper-container', {
			direction: 'vertical',
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
				observer:true, //修改swiper自己或子元素时，自动初始化swiper
				observeParents:true,//修改swiper的父元素时，自动初始化swiper
				},
			});
		},
		methods:{
		  	scrollToTop() {
			  　var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			  	// console.log(scrollTop)
			  	if(scrollTop==0){
			    	$("#header").removeClass("header");
			    }else{
			    	$("#header").addClass("header");
			    }
			},
			toggle(e){
				this.navActive=e
			},
			submitFomAuto() {
				// 自动登录
				var that=this;
				var protocol = window.location.protocol; //http协议
				var domain = window.location.host; //域名
				window.open('zc.91assets.com/login.jsp');
				// var obj={}
				// obj.userName=that.login_userName
				// obj.password=hex_md5(that.login_password)
				// $.ajax({
				// 	url : '/web/main/login',
				// 	type : 'POST',
				// 	dataType : 'json',
				// 	data:JSON.stringify(obj),
				// 	async: false,
				// 	headers:{
				// 		'Content-Type': 'application/JSON',
				// 		'apiFlag':"1"
				// 	},
				// 	success : function(data) {
				// 		localStorage.setItem("login_userName",that.login_userName);
				// 		localStorage.setItem("login_password",that.login_password);
				// 		window.open(protocol+domain+'/web/main/login');
				// 	},
				// 	error : function(msg) {
				// 		window.open('/login.jsp');
				// 	}
				// });

			},
			toLogin(e){
				var protocol = window.location.protocol; //http协议
				var domain = window.location.host; //域名
				window.open('zc.91assets.com/login.jsp');
			},
			toReg(){
				var protocol = window.location.protocol; //http协议
				var domain = window.location.host; //域名
				window.open('zc.91assets.com/company_register.jsp');
			},
			// isPC() {
			// 	var userAgentInfo = navigator.userAgent;
			// 	var Agents = ["Android", "iPhone",
			// 				"SymbianOS", "Windows Phone",
			// 				"iPad", "iPod"];
			// 	var flag = true;
			// 	for (var v = 0; v < Agents.length; v++) {
			// 		if (userAgentInfo.indexOf(Agents[v]) > 0) {
			// 			flag = false;
			// 			break;
			// 		}
			// 	}
			// 	return flag;
			// },
			isOpenMenu(){
				if(this.openMenu){
					this.openMenu=false
				}else{
					this.openMenu=true
				}
			},
			selectMenu(){
				this.openMenu=false
			}

		},
	}
</script>




// WEBPACK FOOTER //
// src/App.vue